import { Pill } from '@mantine/core'

export const ChangeTrackingStatusPill = () => (
  <Pill
    bg="var(--mantine-primary-color-0)"
    c="var(--mantine-primary-color-6)"
    size="md"
    radius="sm"
  >
    Tracking changes
  </Pill>
)
